import { ProductsDataType } from "@/app/shared/ecommerce/dashboard/stock-report";
import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import { productsData } from "@/data/products-data";
import { productsListColumns } from "../../ecommerce/product/product-list/columns";

export default function ModernTable() {
    const { table, setData } = useTanStackTable<ProductsDataType>({
        tableData: productsData,
        columnConfig: productsListColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 7,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
            },
            enableColumnResizing: false,
        },
    });

    return (
        <Table
            table={table}
            variant="modern"
            classNames={{ rowClassName: "last:border-0" }}
        />
    );
}
